/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Link_UrlInputs */

const vi_shop_home_link_url = /** @type {(inputs: Shop_Home_Link_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL ngoài`)
};

/**

* @param {Shop_Home_Link_UrlInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_link_url = /** @type {((inputs?: Shop_Home_Link_UrlInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Link_UrlInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_link_url(inputs)
});